import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { passwordValidation } from "components/Form/ControlledPassword/ControlledPassword";

export function useCredentialsForm(email) {
  const signUpSchema = yup.object({
    email: yup.string().email("Email is invalid").required("Email is required"),
    password: passwordValidation,
    passwordConfirmation: yup
      .string()
      .required("Password confirmation is required")
      .oneOf([yup.ref("password")], "The password you entered does not match"),
  });

  return useForm({
    resolver: yupResolver(signUpSchema),
    criteriaMode: "all",
    mode: "onSubmit",
    defaultValues: { email },
  });
}

export default useCredentialsForm;
